/* Copyright (c) 2026 Xperi. All Rights Reserved. */

/**
 * Where the effective Parental Control settings currently held by the rule
 * engine came from.
 */
enum ParentalSettingsSource {
  /** Freshly read from `GET /v2/deviceFeatures`. Settings may be edited. */
  NETWORK = "NETWORK",

  /** Restored from the local cache during a service outage. Settings are read-only. */
  CACHE = "CACHE"
}

export { ParentalSettingsSource };
